import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateUtility {
    public localizeUTCTimestamp(utcTimestamp: string, timeZone: string): string {
      try {
        const now = new Date(utcTimestamp);
        return  new Intl.DateTimeFormat('en-US', {
          timeZone: timeZone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true
        }).format(now);
      }
      catch (exception) {
        return '';
      }
    }
}